import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSchoolsStart } from "../../redux/questions/reducer";
import {
  selectIsFetchingSchools,
  selectSchools,
} from "../../redux/questions/selectors";

const useSchoolsGet = () => {
  const dispatch = useDispatch();
  const isFetchingSchools = useSelector(selectIsFetchingSchools);
  const schools = useSelector(selectSchools);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);

  const fetchQuestions = useCallback(() => {
    dispatch(getSchoolsStart({
        size:500
    }));
  }, [dispatch]);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions, fetch]);

  return {
    loadingSchools: isFetchingSchools,
    schools,
    refetch,
  };
};

export default useSchoolsGet;
